import { Suspense, lazy } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import RequireAuth from '@/components/RequireAuth';
import '@/components/RequireAuth.scss';
import SimpleLayout from '@/layouts/SimpleLayout';

const StockBoard = lazy(() => import('@/pages/StockBoard'));
const Login = lazy(() => import('@/pages/Login'));
const Register = lazy(() => import('@/pages/Register'));

export default function Router() {
  const routes = useRoutes([
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/register',
      element: <Register />,
    },
    {
      path: '/',
      element: (
        <RequireAuth>
          <SimpleLayout />
        </RequireAuth>
      ),
      children: [
        { index: true, element: <StockBoard /> },
      ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);

  return (
    <Suspense
      fallback={
        <div className="auth-loading">
          <Spin size="large" />
        </div>
      }
    >
      {routes}
    </Suspense>
  );
}
